<template>
    <AppCard class="flex flex-col items-center justify-center">
        <img v-if="model.image" class="max-h-24 max-w-fit mb-2" :src="model.image">

        <div v-else class="text-center">
            <FontAwesomeIcon :icon="['fat', 'car-side']" size="6x"></FontAwesomeIcon>
        </div>

        <p class="text-dark text-lg font-bold mb-2 text-center">
            <template v-if="manufacturer">{{ manufacturer.name }}</template>

            {{ model.name }}
        </p>

    <AppButton class="mb-2 w-full mt-auto" :href="viewTyresLink">
        View tyres
    </AppButton>

        <p class="text-dark">{{ reviewCount }} tyre reviews</p>
    </AppCard>
</template>

<script>
import AppCard from "@/Components/AppCard";
import AppButton from "@/Components/AppButton";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
    components: {AppCard, FontAwesomeIcon, AppButton},
    props: {
        manufacturer: Object,
        model: Object
    },
    computed: {
        reviewCount() {
            if (!this.model.reviews_count) return 0;

            return this.model.reviews_count.toLocaleString();
        },
        viewTyresLink() {
            const manufacturer = this.manufacturer ?? this.model.manufacturer;

            return this.route("manufacturers.models.show", [
                manufacturer, this.model
            ]);
        }
    }
};
</script>

<style scoped>

</style>
